import { createAction } from '@reduxjs/toolkit';

export const clearSortedList = createAction('clearSortedList');
